module.exports = __webpack_public_path__ + "img/vf2.41b8c89d.png";